// extracted by mini-css-extract-plugin
module.exports = {"container":"uploadButton_container__42xgC","input":"uploadButton_input__2kIVW","disabled":"uploadButton_disabled__tzj2b"};